import { createSlice } from '@reduxjs/toolkit';

const EXPIRATION_TIME = 600; // 10 minutos (600 segundos)

const initialState = {
    registrationInfo: [],
    isLoading: false,
    error: false,
    storedAt: null,
};

const registrationSlice = createSlice({
    name: 'registration',
    initialState,
    reducers: {
        registrationRequest: (state) => {
            state.isLoading = true;
            state.error = false;
        },
        setRegistrationinfo: (state, action) => {
            state.registrationInfo = action.payload;
            state.storedAt = Date.now();
            state.isLoading = false;
        },
        setRegistrationerror: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        clearRegistrationInfo: (state) => {
            state.registrationInfo = [];
            state.storedAt = null;
        },
    },
});

export const {
    registrationRequest,
    setRegistrationinfo,
    setRegistrationerror,
    clearRegistrationInfo
} = registrationSlice.actions;


export const getRegistrationInfo = (state) => {
    const { registrationInfo, storedAt } = state.registration;

    if (!registrationInfo || !storedAt) return null;

    const elapsedSeconds = (Date.now() - storedAt) / 1000;

    if (elapsedSeconds > EXPIRATION_TIME) {
        return null; // datos expirados para que no se queden en equipos públicos
    }

    return registrationInfo;
};

export default registrationSlice.reducer;
